import { useEffect, useCallback, useRef } from "react";
import { useBlocker } from "react-router-dom";
import { useConfirm } from "../context/confirmContext";

export default function useUnsavedChanges(isDirty, options = {}) {
    const {
        title = "Unsaved Changes",
        message = "You have unsaved changes. Are you sure you want to leave?",
        confirmLabel = "Leave",
        cancelLabel = "Stay",
    } = options;

    const confirm = useConfirm();
    const confirmRef = useRef(confirm);
    confirmRef.current = confirm;

    const optionsRef = useRef({ title, message, confirmLabel, cancelLabel });
    optionsRef.current = { title, message, confirmLabel, cancelLabel };

    const blocker = useBlocker(
        useCallback(() => isDirty === true, [isDirty])
    );

    useEffect(() => {
        if (blocker.state !== "blocked") return;

        const handleBlock = async () => {
            const opts = optionsRef.current;
            const leave = await confirmRef.current({
                title: opts.title,
                message: opts.message,
                confirmLabel: opts.confirmLabel,
                cancelLabel: opts.cancelLabel,
                variant: "danger",
            });
            if (leave) {
                blocker.proceed();
            } else {
                blocker.reset();
            }
        };

        handleBlock();
    }, [blocker]);

    useEffect(() => {
        if (!isDirty) return;
        const handler = (e) => {
            e.preventDefault();
            e.returnValue = "";
        };
        window.addEventListener("beforeunload", handler);
        return () => window.removeEventListener("beforeunload", handler);
    }, [isDirty]);
}
